import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import PasswordExpiryBanner from "./PasswordExpiryBanner";

export default function PrivateRoute({ children }) {
  const { user, loading } = useContext(AuthContext);

  // ⚡ Mientras cargamos el contexto, no hacemos nada
  if (loading) {
    return <div>Cargando...</div>;
  }

  if (!user || !user.token) {
    return <Navigate to="/login" replace />;
  }

  // (2026-07-05) Banner de aviso de vencimiento de contraseña por encima del
  // contenido autenticado (solo aplica a operador/operador_admin; el componente
  // se autooculta si no procede).
  return (
    <>
      <PasswordExpiryBanner />
      {children}
    </>
  );
}
